module.exports = __webpack_public_path__ + "img/gq.30ed019c.svg";